import React from 'react';
import styled from 'styled-components';
import H1 from '@src/editor/components/H1';
import PlusSign from '@src/editor/components/PlusSign';
import { Colors } from '@src/styles';
import stateSettings from '@state/settings';
import { uuid } from '@src/utils';
import logo from '@src/assets/images/logo.png';
const Wrapper = styled.div `
  padding: 24px;
  flex: 1;
  overflow: scroll;
  max-height: 100vh;
`;
const AddBox = styled.div `
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7%;
  margin-left: 10px;
  vertical-align: middle;
  line-height: 45px;
  background-color: rgb(240, 240, 240);
  color: rgb(152, 161, 164);
  padding: 8px;
  transition: all 200ms ease;

  &:hover {
    background-color: ${Colors.accent};
    color: white;
  }
`;
const Image = styled.img `
  object-fit: contain;
  width: 250px;
  height: 250px;
`;
const ImagesWrapper = styled.div `
  display: grid;
  grid-gap: 32px;
  grid-template-columns: repeat(auto-fit, 250px);
`;
const Input = styled.input `
  outline: 0;
  border: none;
  padding-bottom: 5px;
  transition: all 200ms ease;
  width: 250px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  &:hover {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.35);
  }

  &:focus {
    box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.85);
  }
`;
const onUrlChange = (image) => (e) => {
    image.url = e.target.value;
};
const onDeleteImage = (image) => () => {
    stateSettings.images.splice(stateSettings.images.indexOf(image), 1);
};
const onAddImage = () => {
    const newId = uuid();
    stateSettings.images.unshift({
        id: newId,
        url: logo,
    });
};
const Assets = () => (React.createElement(Wrapper, null,
    React.createElement(H1, null,
        "Images",
        React.createElement(AddBox, { onClick: onAddImage },
            React.createElement(PlusSign, null))),
    React.createElement(ImagesWrapper, null, stateSettings.images.map((img) => (React.createElement("div", { key: img.id },
        React.createElement("div", { onClick: onDeleteImage(img) },
            React.createElement("i", { className: "material-icons" }, "clear")),
        React.createElement(Image, { src: img.url, key: img.id }),
        React.createElement(Input, { type: "text", placeholder: "Url", id: img.id, name: img.id, value: img.url, onChange: onUrlChange(img) })))))));
export default Assets;
